// TuniaoUI颜色值
export default {
  mainColor: '#01BEFF',
  reverseMainColor: '#FFF00D',
  femaleColor: '#FF71D2',
  maleColor: '#82B2FF',
  mainOrange: '#FBBD12',
  bgColor: '#FFFFFF',
  spaceColor: '#F8F7F8',
  fontColor: '#080808',
  fontSubColor: '#AAAAAA',
  contentColor: '#838383',
  fontHolderColor: '#E6E6E6',
  maskBgColor: 'rgba(0, 0, 0, 0.4)',
}